import {
	buildItem,
	getAnnualProgramItemCategory2,
	pushEvent,
	type BuildItemInput
} from '@/_utils/analytics/datalayer'

import type {
	AnnualProgramSlugGa4Config,
	AnnualProgramSlugGa4ViewItemConfig,
	Ga4TbdValue
} from '../_types/annual-program-slug-ga4.types'
import type { IAnnualProgram } from '@/_types'

function isTbd<T>(value: Ga4TbdValue<T>): value is 'TBD' {
	return value === 'TBD'
}

function resolveField<T>(configValue: Ga4TbdValue<T>, fallback: T | undefined): T | undefined {
	if (isTbd(configValue)) return fallback
	return configValue
}

function resolveViewItemInput(
	config: AnnualProgramSlugGa4ViewItemConfig,
	program: IAnnualProgram | undefined,
	itemCategory2Fallback: string | undefined
): BuildItemInput & { item_category2?: string } | null {
	const id = resolveField(config.id, program?.id)
	const name = resolveField(config.name, program?.name)
	const price = resolveField(config.price, program?.price)
	const priceOld = resolveField(config.priceOld ?? 'TBD', program?.priceOld ?? undefined)
	const item_category2 = resolveField(config.item_category2, itemCategory2Fallback)

	if (id == null || !name || price == null) return null

	return {
		id,
		name,
		type: config.type,
		price,
		priceOld,
		item_category2
	}
}

export function pushAnnualProgramSlugViewItem(
	ga4: AnnualProgramSlugGa4Config | undefined,
	programId: number,
	program: IAnnualProgram | undefined,
	itemCategory2Fallback: string | undefined
): void {
	if (!ga4?.viewItem?.length) return

	const viewItemConfig = ga4.viewItem.find(item => item.programId === programId)
	if (!viewItemConfig) return

	const resolved = resolveViewItemInput(viewItemConfig, program, itemCategory2Fallback)
	if (!resolved) return

	const { item_category2, ...itemInput } = resolved
	const item = buildItem(itemInput, {
		...(item_category2 !== undefined && { item_category2 })
	})

	const currency = isTbd(ga4.currency ?? 'TBD') ? 'EUR' : ga4.currency

	pushEvent('view_item', {
		currency,
		value: itemInput.price ?? 0,
		items: [item]
	})
}

export function configLabelToPrimaryCategory(
	label: string
): 'male' | 'female' | 'child' | undefined {
	const normalized = label.trim().toLowerCase()
	if (normalized === 'ženy' || normalized === 'zeny') return 'female'
	if (normalized === 'muži' || normalized === 'muzi') return 'male'
	if (normalized === 'deti') return 'child'
	return undefined
}

export function getItemCategory2FromConfigLabel(label: string): string | undefined {
	const primaryCategory = configLabelToPrimaryCategory(label)
	if (!primaryCategory) return undefined
	return getAnnualProgramItemCategory2({ primaryCategory })
}
